import { TreeDataNode } from "antd";

export const dataTypeTreeDataForLeasesAndOther: TreeDataNode[] = [
  // Operating Leases
  {
    title: "Operating Leases",
    key: "Operating Leases",
    children: [
        {
        title: "Total Operating Lease Expense",
        key: "Operating Leases_Total Operating Lease Expense",
        children: [
          { title: "Lease 1", key: "Operating Leases_Total Operating Lease Expense_Lease 1", isLeaf: true },
          { title: "Lease 2", key: "Operating Leases_Total Operating Lease Expense_Lease 2", isLeaf: true },
          { title: "Lease 3", key: "Operating Leases_Total Operating Lease Expense_Lease 3", isLeaf: true },
        ],
      },
      {
        title: "Lease Payments Due",
        key: "Operating Leases_Lease Payments Due",
        children: [
          { title: "Lease 1", key: "Operating Leases_Lease Payments Due_Lease 1", isLeaf: true },
          { title: "Lease 2", key: "Operating Leases_Lease Payments Due_Lease 2", isLeaf: true },
          { title: "Lease 3", key: "Operating Leases_Lease Payments Due_Lease 3", isLeaf: true },
        ],
      },
      {
        title: "Imputed Interest Expense",
        key: "Operating Leases_Imputed Interest Expense",
        children: [
          { title: "Lease 1", key: "Operating Leases_Imputed Interest Expense_Lease 1", isLeaf: true },
          { title: "Lease 2", key: "Operating Leases_Imputed Interest Expense_Lease 2", isLeaf: true },
          { title: "Lease 3", key: "Operating Leases_Imputed Interest Expense_Lease 3", isLeaf: true },
        ],
      },
    ],
  },

  // Finance Leases
  {
    title: "Finance Leases",
    key: "Finance Leases",
    children: [
      {
        title: "Total Financing Lease Cost",
        key: "Finance Leases_Total Financing Lease Cost",
        children: [
          { title: "Lease 1", key: "Finance Leases_Total Financing Lease Cost_Lease 1", isLeaf: true },
          { title: "Lease 2", key: "Finance Leases_Total Financing Lease Cost_Lease 2", isLeaf: true },
          { title: "Lease 3", key: "Finance Leases_Total Financing Lease Cost_Lease 3", isLeaf: true },
        ],
      },
      {
        title: "Amortization Expense",
        key: "Finance Leases_Amortization Expense",
        children: [
          { title: "Lease 1", key: "Finance Leases_Amortization Expense_Lease 1", isLeaf: true },
          { title: "Lease 2", key: "Finance Leases_Amortization Expense_Lease 2", isLeaf: true },
          { title: "Lease 3", key: "Finance Leases_Amortization Expense_Lease 3", isLeaf: true },
        ],
      },
      {
        title: "Interest Expense",
        key: "Finance Leases_Interest Expense",
        children: [
          { title: "Lease 1", key: "Finance Leases_Interest Expense_Lease 1", isLeaf: true },
          { title: "Lease 2", key: "Finance Leases_Interest Expense_Lease 2", isLeaf: true },
          { title: "Lease 3", key: "Finance Leases_Interest Expense_Lease 3", isLeaf: true },
        ],
      },
      {
        title: "Lease Payments Due",
        key: "Finance Leases_Lease Payments Due",
        children: [
          { title: "Lease 1", key: "Finance Leases_Lease Payments Due_Lease 1", isLeaf: true },
          { title: "Lease 2", key: "Finance Leases_Lease Payments Due_Lease 2", isLeaf: true },
          { title: "Lease 3", key: "Finance Leases_Lease Payments Due_Lease 3", isLeaf: true },
        ],
      },
      {
        title: "Imputed Interest Expense",
        key: "Finance Leases_Imputed Interest Expense",
        children: [
          { title: "Lease 1", key: "Finance Leases_Imputed Interest Expense_Lease 1", isLeaf: true },
          { title: "Lease 2", key: "Finance Leases_Imputed Interest Expense_Lease 2", isLeaf: true },
          { title: "Lease 3", key: "Finance Leases_Imputed Interest Expense_Lease 3", isLeaf: true },
        ],
      },
    ],
  },

  // Pensions and Other Post-Retirement Benefit Plans
  {
    title: "Pensions and Other Post-Retirement Benefit Plans",
    key: "Pensions and Other Post-Retirement Benefit Plans",
    children: [
      {
        title: "Benefit Obligation",
        key: "Pensions and Other Post-Retirement Benefit Plans_Benefit Obligation",
        children: [
          { title: "Plan 1", key: "Pensions and Other Post-Retirement Benefit Plans_Benefit Obligation_Plan 1", isLeaf: true },
          { title: "Plan 2", key: "Pensions and Other Post-Retirement Benefit Plans_Benefit Obligation_Plan 2", isLeaf: true },
          { title: "Plan 3", key: "Pensions and Other Post-Retirement Benefit Plans_Benefit Obligation_Plan 3", isLeaf: true },
          { title: "Plan 4", key: "Pensions and Other Post-Retirement Benefit Plans_Benefit Obligation_Plan 4", isLeaf: true },
          { title: "Plan 5", key: "Pensions and Other Post-Retirement Benefit Plans_Benefit Obligation_Plan 5", isLeaf: true },
        ],
      },
      {
        title: "Fair Value of Plan Assets",
        key: "Pensions and Other Post-Retirement Benefit Plans_Fair Value of Plan Assets",
        children: [
          { title: "Plan 1", key: "Pensions and Other Post-Retirement Benefit Plans_Fair Value of Plan Assets_Plan 1", isLeaf: true },
          { title: "Plan 2", key: "Pensions and Other Post-Retirement Benefit Plans_Fair Value of Plan Assets_Plan 2", isLeaf: true },
          { title: "Plan 3", key: "Pensions and Other Post-Retirement Benefit Plans_Fair Value of Plan Assets_Plan 3", isLeaf: true },
          { title: "Plan 4", key: "Pensions and Other Post-Retirement Benefit Plans_Fair Value of Plan Assets_Plan 4", isLeaf: true },
          { title: "Plan 5", key: "Pensions and Other Post-Retirement Benefit Plans_Fair Value of Plan Assets_Plan 5", isLeaf: true },
        ],
      },
      {
        title: "Service Costs",
        key: "Pensions and Other Post-Retirement Benefit Plans_Service Costs",
        children: [
          { title: "Plan 1", key: "Pensions and Other Post-Retirement Benefit Plans_Service Costs_Plan 1", isLeaf: true },
          { title: "Plan 2", key: "Pensions and Other Post-Retirement Benefit Plans_Service Costs_Plan 2", isLeaf: true },
          { title: "Plan 3", key: "Pensions and Other Post-Retirement Benefit Plans_Service Costs_Plan 3", isLeaf: true },
          { title: "Plan 4", key: "Pensions and Other Post-Retirement Benefit Plans_Service Costs_Plan 4", isLeaf: true },
          { title: "Plan 5", key: "Pensions and Other Post-Retirement Benefit Plans_Service Costs_Plan 5", isLeaf: true },
        ],
      },
      {
        title: "Net Period Benefit Cost",
        key: "Pensions and Other Post-Retirement Benefit Plans_Net Period Benefit Cost",
        children: [
          { title: "Plan 1", key: "Pensions and Other Post-Retirement Benefit Plans_Net Period Benefit Cost_Plan 1", isLeaf: true },
          { title: "Plan 2", key: "Pensions and Other Post-Retirement Benefit Plans_Net Period Benefit Cost_Plan 2", isLeaf: true },
          { title: "Plan 3", key: "Pensions and Other Post-Retirement Benefit Plans_Net Period Benefit Cost_Plan 3", isLeaf: true },
          { title: "Plan 4", key: "Pensions and Other Post-Retirement Benefit Plans_Net Period Benefit Cost_Plan 4", isLeaf: true },
          { title: "Plan 5", key: "Pensions and Other Post-Retirement Benefit Plans_Net Period Benefit Cost_Plan 5", isLeaf: true },
        ],
      },  
    ],
  },

  // Contingent Liabilities
  {
    title: "Contingent Liabilities",
    key: "Contingent Liabilities",
    isLeaf: true,
  },

  // Non-Controlling Interest (single-level leaves)
  {
    title: "Non-Controlling Interest",
    key: "Non-Controlling Interest",
    children: [
      {
        title: "Currency Denomination",
        key: "Non-Controlling Interest_Currency Denomination",
        isLeaf: true,
      },
      {
        title: "Intrinsic Value",
        key: "Non-Controlling Interest_Intrinsic Value",
        isLeaf: true,
      },
      {
        title: "LTM Net Income to NCI",
        key: "Non-Controlling Interest_LTM Net Income to NCI",
        isLeaf: true,
      },
      {
        title: "LTM Non-GAAP EPS",
        key: "Non-Controlling Interest_LTM Non-GAAP EPS",
        isLeaf: true,
      },
    
    ],
  },
  // Other Debt
  {
    title: "Other Debt",
    key: "Other Debt",
    children: [
      {
        title: "Principal Value",
        key: "Other Debt_Principal Value",
        children: [
          { title: "Tranche 1", key: "Other Debt_Principal Value_Tranche 1", isLeaf: true },
          { title: "Tranche 2", key: "Other Debt_Principal Value_Tranche 2", isLeaf: true },
          { title: "Tranche 3", key: "Other Debt_Principal Value_Tranche 3", isLeaf: true },
        ],
      },
    ],
  },
];
